// removed by extract-text-webpack-plugin
module.exports = {"filterCol":"MJDmwbAAZNWNEQteD-0T0","filterField":"_21uzst-QWZzEBz83jY_CWb","searchIcon":"_6Trd4icMT5K848-P4mtoQ","addCol":"_3gJebhlEgPebwWObrIIOU5","addText":"_171Tq5_HuGdTS6IcItj1hm","addIcon":"_38Jw0raaVB1BzIOgybcw8q","closeIcon":"_2bWd5wAy6x9wXJIZl1eXES","downloadExcelButton":"_2YIuK2CsLJsD24YYgL8fng"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/FilterClientForm.css
// module id = 726
// module chunks = 0